import React from "react";

const Bash_Sort = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Sort</h2>
      <p>Sort lines of text files.</p>
      <h4 className="font-medium mt-4">Syntax</h4>
      <pre><code>sort [options] [file]</code></pre>
      <h4 className="font-medium mt-4">Examples</h4>
      <pre><code>sort file.txt
sort -r file.txt
sort -n numbers.txt</code></pre>
      <h4 className="font-medium mt-4">Notes</h4>
      <p>Combine with uniq to count unique lines.</p>
    </div>
  );
};

export default Bash_Sort;
